import { onboardingVariant } from './posthog-init.js'

document.addEventListener('DOMContentLoaded', function() {

    // --- Funnel arm "facts_early": show the progress-facts interstitial right after
    // "Get Started"/"Get Started Today", before registration. Re-point the landing CTAs
    // to progress_facts.html for that third of visitors; it continues into registration.
    // Match by href suffix because Parcel rewrites build-time links to "/registration_page.html".
    if (onboardingVariant === 'facts_early') {
        document.querySelectorAll('a[href]').forEach(link => {
            if ((link.getAttribute('href') || '').endsWith('registration_page.html')) {
                link.setAttribute('href', '/registration_htmls/progress_facts.html');
            }
        });
    }

    // --- Smooth Scrolling for Navigation Links ---
    const navLinks = document.querySelectorAll('header nav a[href^="#"]');

    navLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault(); // Prevent default anchor jump

            const targetId = this.getAttribute('href');
            const targetElement = document.querySelector(targetId);

            if (targetElement) {
                 targetElement.scrollIntoView({
                     behavior: 'smooth',
                     block: 'start' // Aligns target to the top, respecting scroll-padding-top
                 });
            }
        });
    });

    // --- Intersection Observer for Feature Animations ---
    // === CHANGED SELECTOR BELOW ===
    const featureBlocks = document.querySelectorAll('.feature-block');
    // === END CHANGED SELECTOR ===

    const observerOptions = {
        root: null, // relative to document viewport
        rootMargin: '0px',
        threshold: 0.1 // Trigger when 10% of the element is visible
    };

    const observerCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target); // Stop observing once animated
            }
        });
    };

    const featureObserver = new IntersectionObserver(observerCallback, observerOptions);

    // === CHANGED VARIABLE BELOW ===
    featureBlocks.forEach(block => {
        featureObserver.observe(block);
    });
    // === END CHANGED VARIABLE ===

    // --- Mobile Nav Toggle (hamburger on small screens) ---
    const navToggle = document.querySelector('.nav-toggle');
    const navMenu = document.querySelector('.nav-links');

    if (navToggle && navMenu) {
        const closeMenu = () => {
            navMenu.classList.remove('open');
            navToggle.classList.remove('open');
            navToggle.setAttribute('aria-expanded', 'false');
        };

        navToggle.addEventListener('click', () => {
            const isOpen = navMenu.classList.toggle('open');
            navToggle.classList.toggle('open', isOpen);
            navToggle.setAttribute('aria-expanded', String(isOpen));
        });

        navMenu.addEventListener('click', (e) => {
            if (e.target.closest('a')) closeMenu();
        });

        document.addEventListener('click', (e) => {
            if (!e.target.closest('header nav')) closeMenu();
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') closeMenu();
        });
    }

});